import React from 'react'
import moment from 'moment'

import {
  Box,
  Grid,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import { Barcode } from '../Barcode'
import { Shipment } from '../../api/models'

const useStyles = makeStyles(() => ({
  table: {
    maxWidth: '80%',
    margin: 'auto',
    marginTop: '2rem',
  },
  label: {
    maxWidth: '90%',
    margin: 'auto',
    border: '1px solid gray',
    borderRadius: '1rem',
    padding: '0.5rem',
  },
  leftColumnData: {
    borderLeft: '1px solid gray',
    borderRight: '1px solid gray',
  },
  rightColumnData: {
    borderRight: '1px solid gray',
  },
  rowData: {
    borderTop: '1px solid gray',
    borderBottom: '1px solid gray',
  },
}))

const billableActivity = [
  'Pallets Handling In',
  'Parcel In',
  'Pallet Storage',
  'Returns',
  'Container Unload-20 ft',
  'Container Unload-40 ft',
  'Transload',
  'Crossdock',
  'Drayage Transportation',
  'New Cartonflow Storage',
  'New Bin Storage',
  'Labeling Fee',
  'Pallet Supply',
  'Pallet Wrap',
  'Labor',
]
const responsibleInfo = ['Received by', 'Put away by', 'Put away location']

interface Props {
  shipment: Shipment
}

export const ShipmentLabel = (props: Props) => {
  const { shipment } = props
  const barcode = { barcode: shipment.guid, type: 'datamatrix', displayName: '' }
  const classes = useStyles()

  return (
    <div className="always-page-break">
      <Box px={10} pt={20}>
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={4}
          className={classes.label}
        >
          <Grid item xs={3}>
            <Barcode barcode={barcode} />
          </Grid>
          <Grid item xs={9}>
            <Box>
              <Typography variant="h1">{shipment.name}</Typography>
            </Box>
            <Box>
              <Typography variant="h5">{shipment.guid}</Typography>
            </Box>
            <Box>
              <Typography variant="caption">Printed on {moment().format('lll')}</Typography>
            </Box>
          </Grid>
        </Grid>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '60%' }}>Billabe Activity</TableCell>
              <TableCell align="center">Quantity</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {billableActivity.map((item) => (
              <TableRow key={item} className={classes.rowData}>
                <TableCell className={classes.leftColumnData}>{item}</TableCell>
                <TableCell className={classes.rightColumnData}></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Table className={classes.table} size="small">
          <TableBody>
            {responsibleInfo.map((item) => (
              <TableRow key={item} className={classes.rowData}>
                <TableCell className={classes.leftColumnData} style={{ width: '40%' }}>
                  {item}
                </TableCell>
                <TableCell className={classes.rightColumnData}></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </div>
  )
}
